<div class="card !p-0 !mb-4">
    <p-breadcrumb [home]="home" [model]="items" />
</div>
@if(productTemp && !productTemp.id) {
  <div class="flex flex-col items-center justify-center mb-4">
    Pour ajouter un produit, uplaoder d'abord une image via le bouton ci-dessous.
    <p-button (click)="showOcrModal()" icon="pi pi-image" label="Sélectionner une image" class="mt-2"/>
  </div>
}
@if(productTemp && productTemp.id) {
  <div class="flex flex-row gap-4">
    <div>
      <img [src]="apiUrl + productTemp.photo_couverture" class="object-cover aspect-square w-48 h-48 rounded-md" alt="img" />
    </div>
    <div class="flex-1">
      <form #productForm="ngForm" (ngSubmit)="onSubmit()">
        <div class="card">
          <div class="grid grid-cols-2 gap-4">
            <div class="col-span-1">
              <p-floatlabel variant="in" class="mb-2">
                <p-select #marque="ngModel" [options]="brands" [(ngModel)]="productTemp.marque" optionLabel="nom" [filter]="true" fluid name="marque" id="marque" filterBy="nom" required [showClear]="true" [loading]="false" [showClear]="true" (onFilter)="onBrandFilter($event)" />
                <label for="marque">Marque*</label>
              </p-floatlabel>
              <small id="marque-help">Sélectionner le marque dans la liste (obligatoire)</small>
              @if (marque.invalid && (marque.dirty || marque.touched)) {
                <p-message severity="error" variant="simple">Le marque est obligatoire</p-message>
              }
            </div>
        
            <div class="col-span-1">
              <p-floatlabel variant="in" class="mb-2">
                <p-select #gamme="ngModel" [options]="ranges" [(ngModel)]="productTemp.gamme" optionLabel="nom" [filter]="true" fluid name="gamme" id="gamme" filterBy="nom" [showClear]="true" [loading]="false" [lazy]="true" [showClear]="true" (onFilter)="onRangeFilter($event)" />
                <label for="gamme">Gamme</label>
              </p-floatlabel>
              <small id="gamme-help">Sélectionner le gamme dans la liste</small>
            </div>
    
            <div class="col-span-2">
              <p-floatlabel variant="in" class="mb-2">
                <input pInputText #reference="ngModel" [(ngModel)]="productTemp.reference" fluid name="reference" id="reference" autocomplete="off" aria-describedby="reference-help" required />
                <label for="reference">Référence*</label>
              </p-floatlabel>
              <small id="reference-help">Référence du produit (obligatoire)</small>
              @if (reference.invalid && (reference.dirty || reference.touched)) {
                <p-message severity="error" variant="simple">La référence est obligatoire</p-message>
              }
            </div>
    
            <div class="col-span-1">
              <p-floatlabel variant="in" class="mb-2">
                <p-select #category="ngModel" [options]="categories" [(ngModel)]="productTemp.categorie" optionLabel="nom" [filter]="true" fluid name="category" id="category" filterBy="nom" [showClear]="true" [loading]="false" [lazy]="true" [showClear]="true" (onFilter)="onCategoryFilter($event)" />
                <label for="category">Catégorie</label>
              </p-floatlabel>
              <small id="category-help">Sélectionner le catégorie dans la liste</small>
            </div>
    
            <div class="col-span-1">
              <p-floatlabel variant="in" class="mb-2">
                <p-select #subcategory="ngModel" [options]="subCategories" [(ngModel)]="productTemp.sous_categorie" optionLabel="nom" [filter]="true" fluid name="subcategory" id="subcategory" filterBy="nom" [showClear]="true" [loading]="false" [lazy]="true" [showClear]="true" (onFilter)="onSubCategoryFilter($event)" />
                <label for="subcategory">Sous Catégorie</label>
              </p-floatlabel>
              <small id="subcategory-help">Sélectionner le sous-catégorie dans la liste</small>
            </div>
    
            <div class="col-span-2">
              <p-floatlabel variant="in" class="mb-2">
                <textarea pTextarea #description="ngModel" [(ngModel)]="productTemp.description" rows="5" fluid name="description" id="description" autocomplete="off" aria-describedby="description-help"></textarea>
                <label for="description">Description</label>
              </p-floatlabel>
              <small id="description-help">Description du produit</small>
            </div>
    
          </div>
        </div>
    
        <div class="flex flex-row justify-between">
          <p-button label="Annuler" icon="pi pi-times" text severity="danger" (click)="resetForm()" />
          <p-button label="Valider" icon="pi pi-save" iconPos="right" type="submit" [disabled]="!productForm.valid" [loading]="isSendingDatas" (click)="onSubmit()" />
        </div>
      </form>
    </div>
  </div>
}